import Container from "partials/Container";
import { BookVisitWidget } from "./BookVisitWidget";
import WP from "WP";

export const BookVisitAvailabilityChecker = () => (
  <Container>
    <BookVisitWidget
      config={{
        channelId: "671b3392-484a-4b34-b3c2-00a072062e52",
        widgetLayout: "StandardWide",
        WidgetContainerId: "widgetContainer",
        promoCode: false,
        corpCode: false,
        agentCode: false,
        openOption: "redirect",
        loginLink: false,
        currency: "NOK",
        languageCulture: WP.lang === "no" ? "nb" : "en",
        accommodationTypePicker: false,
        type: "single_property",
      }}
    />
  </Container>
);
